"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupportList = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var bankCard_1 = require("../../model/bankCard");
var service_1 = require("../../../library/base/service");
var SupportList = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(SupportList, _super);
    function SupportList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '支持银行列表接口';
        _this.code = '101062';
        _this.desc = '支持银行列表接口';
        _this.requestParams = new bankCard_1.SupportListRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return SupportList;
}(service_1.BaseService));
exports.SupportList = SupportList;
//# sourceMappingURL=supportList.js.map